import * as React from "react";
import { Image } from "azure-devops-ui/Image";

export default class ImageExample extends React.Component {
    public render(): JSX.Element {
        return <Image alt="Bars image" src={require("./bars.png")} />;
    }
}
